/**
 * Document GraphQL Mutations
 *
 * 7 mutations for document lifecycle, versioning, and approval workflows.
 */

import { gql } from '@apollo/client';
import { DOCUMENT_FIELDS_FRAGMENT } from './fragments';

export const CREATE_DOCUMENT = gql`
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const UPDATE_DOCUMENT_STATUS = gql`
  mutation UpdateDocumentStatus($input: UpdateDocumentStatusInput!) {
    updateDocumentStatus(input: $input) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const CREATE_DOCUMENT_VERSION = gql`
  mutation CreateDocumentVersion($input: CreateDocumentVersionInput!) {
    createDocumentVersion(input: $input) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const SUBMIT_DOCUMENT_FOR_APPROVAL = gql`
  mutation SubmitDocumentForApproval($tenantId: String!, $documentId: String!, $approverActorIds: [String!]!) {
    submitDocumentForApproval(tenantId: $tenantId, documentId: $documentId, approverActorIds: $approverActorIds) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const RECORD_DOCUMENT_APPROVAL_DECISION = gql`
  mutation RecordDocumentApprovalDecision(
    $tenantId: String!
    $documentId: String!
    $approverId: String!
    $decision: String!
    $comment: String
  ) {
    recordDocumentApprovalDecision(
      tenantId: $tenantId
      documentId: $documentId
      approverId: $approverId
      decision: $decision
      comment: $comment
    ) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const DELETE_DOCUMENT = gql`
  mutation DeleteDocument($documentId: String!) {
    deleteDocument(documentId: $documentId) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const ARCHIVE_DOCUMENT = gql`
  mutation ArchiveDocument($tenantId: String!, $documentId: String!) {
    archiveDocument(tenantId: $tenantId, documentId: $documentId) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;
